import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function LogoutModal({ open, handleClose }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));

      await axios.post(
        "https://vsoftapi.com-eg.net/api/Users/V1/Logout",
        {},
        {
          headers: {
            CompanyID: userData?.Data?.CompanyID,
            AccessToken: userData?.Data?.AccessToken,
          },
        }
      );
    } catch (error) {
      // إذا كانت حالة الرد 401 Unauthorized
      if (error.response && error.response.status === 401) {
        console.log("Session expired, logging out...");
      } else {
        console.error("Error logging out:", error);
      }
    } finally {
      localStorage.removeItem("userData");
      navigate("/");
      setLoading(false);
    }
  };

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle
          sx={{
            textAlign: "center",
            fontSize: "22px",
            color: "primary.main",
            fontWeight: "bold",
          }}
        >
          {t("confirmLogOut")}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{ textAlign: "center", marginBottom: 2 }}
          >
            {t("areYouSureWantToLogOut")}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
            disabled={loading}
          >
            {t("cancel")}
          </Button>
          <Button
            onClick={handleLogout}
            variant="contained"
            color="secondary"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              t("confirm") // Remove quotes to call the function directly
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
